export default __webpack_public_path__ + "static/media/skillit-logo-rubber_no-symbol.f1769e96.png";